import { type EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

export interface LoginRoutePolicy {
  loginRoute: string;
  businessOwnerRoute: string;
  defaultRoute: string;
  accessDeniedRoute: string;
}

export interface LoginFlowMessages {
  businessOwnerAccessDenied: string;
}

export const LOGIN_ROUTE_POLICY = new InjectionToken<LoginRoutePolicy>(
  'LOGIN_ROUTE_POLICY',
  {
    providedIn: 'root',
    factory: () => ({
      loginRoute: '/auth/login',
      businessOwnerRoute: '/business-owner-dashboard',
      defaultRoute: '/dashboard',
      accessDeniedRoute: '/dashboard',
    }),
  }
);

export const LOGIN_FLOW_MESSAGES = new InjectionToken<LoginFlowMessages>(
  'LOGIN_FLOW_MESSAGES',
  {
    providedIn: 'root',
    factory: () => ({
      businessOwnerAccessDenied: 'Tu cuenta no tiene permisos de business owner.',
    }),
  }
);

export function provideLoginRoutePolicy(policy: LoginRoutePolicy): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LOGIN_ROUTE_POLICY, useValue: policy },
  ]);
}

export function provideLoginFlowMessages(messages: LoginFlowMessages): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LOGIN_FLOW_MESSAGES, useValue: messages },
  ]);
}